import Vuex from 'vuex';
import Vue from 'vue';
import localization from './modules/Localization';
import Assistant from "./modules/Assistant";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        localization,
        Assistant,
    }
});
